/**
 * Created by andrey on 19.09.2025
 */

const G5Logger = function () {
    this.config = {
        lifetime: "180 days"
    };
};

G5Logger.prototype.trackEvent = function (name, params) {
    connector.platform.callNative("analytics.logEvent", { name, params });
};

G5Logger.isApplicable = function () {
    return connector.platform.oneOf(connector.G5WINDOWS);
};